/**
 * WindowResizeListener
 * React component for listening to window resize events and modified by Chuck Ludwig
 * Originally from here: https://github.com/cesarandreu/react-window-resize-listener
 */
import { debounce } from "lodash";
import React from "react";

interface Props {
  onResize: (size: { windowWidth: number; windowHeight: number }) => void;
}
export default class WindowResizeListener extends React.Component<Props> {
  _listeners: any[];
  DEBOUNCE_TIME = 100;
  _debouncedResize: any;
  constructor(props) {
    super(props);
    this.state = {};
    this._listeners = [];
    this._onResize = this._onResize.bind(this);
  }

  _onResize() {
    var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var windowHeight = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight || document.body.clientHeight;

    this._listeners.forEach(function (listener) {
      listener({
        windowWidth: windowWidth,
        windowHeight: windowHeight
      });
    });
  }

  componentDidMount() {
    // Defer creating _debouncedResize until it's mounted
    // This allows users to change DEBOUNCE_TIME if they want
    // If there's no listeners, we need to attach the window listener
    if (!this._listeners.length) {
      this._debouncedResize = debounce(this._onResize, this.DEBOUNCE_TIME);
      window.addEventListener("resize", this._debouncedResize, false);
    }
    this._listeners.push(this.props.onResize);
    this._debouncedResize();
  }

  componentWillUnmount() {
    var idx = this._listeners.indexOf(this.props.onResize);
    this._listeners.splice(idx, 1);
    if (!this._listeners.length) {
      window.removeEventListener("resize", this._debouncedResize, false);
    }
  }

  render() {
    return null;
  }
}
